export const buildApiUrl = (endpointUri?:string) => import.meta.env.VITE_API_URL + (endpointUri || "")